import { useEffect, useMemo, useState } from "react";

// Countdown ends 7 days from when the user first lands
const STORAGE_KEY = "aigl_countdown_target";

function getTarget() {
  let t = localStorage.getItem(STORAGE_KEY);
  if (!t) {
    const dt = new Date();
    dt.setDate(dt.getDate() + 7);
    t = dt.toISOString();
    localStorage.setItem(STORAGE_KEY, t);
  }
  return new Date(t);
}

export const CountdownTimer = ({ variant = "hero" }) => {
  const target = useMemo(getTarget, []);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const diff = Math.max(0, target.getTime() - now);
  const d = Math.floor(diff / (1000 * 60 * 60 * 24));
  const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const m = Math.floor((diff / (1000 * 60)) % 60);
  const s = Math.floor((diff / 1000) % 60);

  const cell = (n, label) => (
    <div className="flex flex-col items-center px-3 sm:px-5">
      <div
        data-testid={`countdown-${label.toLowerCase()}`}
        className={`countdown-num ${
          variant === "hero" ? "text-3xl sm:text-5xl text-[#C5A059]" : "text-2xl text-[#0A192F]"
        }`}
      >
        {String(n).padStart(2, "0")}
      </div>
      <div
        className={`font-accent text-[10px] sm:text-xs mt-1 ${
          variant === "hero" ? "text-white/70" : "text-slate-500"
        }`}
      >
        {label}
      </div>
    </div>
  );

  return (
    <div
      data-testid="countdown-timer"
      className={`inline-flex items-center ${
        variant === "hero" ? "" : "bg-white border border-slate-200 px-4 py-2 rounded-sm"
      }`}
    >
      {cell(d, "Days")}
      <div className={variant === "hero" ? "text-[#C5A059]/40 text-3xl" : "text-slate-300"}>:</div>
      {cell(h, "Hours")}
      <div className={variant === "hero" ? "text-[#C5A059]/40 text-3xl" : "text-slate-300"}>:</div>
      {cell(m, "Mins")}
      <div className={variant === "hero" ? "text-[#C5A059]/40 text-3xl" : "text-slate-300"}>:</div>
      {cell(s, "Secs")}
    </div>
  );
};
